import { QueryOptions, queryOptions } from '@tanstack/react-query';
import { service } from '@maia/claim';

export type Claims = Awaited<ReturnType<(typeof service)['getClaim']>>;

export function getClaimOptions(
  guid: string,
  initialData: QueryOptions<Claims>['initialData'] = undefined,
) {
  return queryOptions({
    queryKey: ['claims', 'claims', guid],
    queryFn: async () => await service.getClaim(guid),
    initialData,
  });
}

export type Tasks = Awaited<ReturnType<(typeof service)['getTasks']>>;

export function getTasksOptions(
  guid: string,
  initialData: QueryOptions<Tasks>['initialData'] = undefined,
) {
  return queryOptions({
    queryKey: ['claims', 'tasks', guid],
    queryFn: async () =>
      await service.getTasks(guid, { limit: 3, filter: ['status,in_review'] }),
    initialData,
  });
}

export type Activities = Awaited<ReturnType<(typeof service)['getActivities']>>;

export function getActivitiesOptions(
  guid: string,
  initialData: QueryOptions<Activities>['initialData'] = undefined,
  limit?: number,
) {
  return queryOptions({
    queryKey: ['claims', 'activities', guid],
    queryFn: async () => await service.getActivities(guid, { limit: limit }),
    initialData,
  });
}

export type Notes = Awaited<ReturnType<(typeof service)['getNotes']>>;

export function getNotesOptions(
  guid: string,
  search: Record<string, unknown> = {},
  initialData: QueryOptions<Notes>['initialData'] = undefined,
) {
  return queryOptions({
    queryKey: ['notes', guid],
    queryFn: async () => await service.getNotes(guid, search),
    initialData,
  });
}
